import { LayoutList, TrendingUp, TrendingDown } from "lucide-react";

export function BrandsTable({ brands }) {
  if (!brands || brands.length === 0) return null;

  return (
    <div data-testid="brands-table" style={{ flex: 1, display: "flex", flexDirection: "column" }}>
      <div className="panel-header">
        <span className="panel-title">
          <LayoutList size={10} strokeWidth={1.5} style={{ display: "inline", marginRight: 6 }} />
          MARCAS ACTIVAS
        </span>
        <span className="font-mono" style={{ fontSize: 9, color: "#71717a" }}>
          {brands.length} TOTAL
        </span>
      </div>

      <div className="brand-row brand-row-header">
        <span>MARCA / NICHO</span>
        <span>TERRITORIO</span>
        <span>ESTADO</span>
        <span style={{ textAlign: "right" }}>VENTAS</span>
        <span style={{ textAlign: "right" }}>REVENUE</span>
        <span style={{ textAlign: "right" }}>ROI</span>
      </div>

      <div className="panel-body">
        {brands.map((brand, i) => {
          const roi = brand.api_cost_usd > 0
            ? ((brand.revenue_usd - brand.api_cost_usd) / brand.api_cost_usd * 100).toFixed(0)
            : 0;
          const roiPositive = Number(roi) > 0;

          return (
            <div key={brand.id || i} className="brand-row" data-testid={`brand-row-${i}`}>
              <div>
                <div style={{ fontWeight: 500, color: "#fff", fontSize: 13 }}>{brand.name}</div>
                <div className="font-mono" style={{ fontSize: 9, color: "#71717a", marginTop: 1 }}>
                  {brand.niche} / {brand.product_type}
                </div>
              </div>
              <div>
                <div className="font-mono" style={{ fontSize: 11, color: "#a1a1aa" }}>{brand.territory}</div>
                <div className="font-mono" style={{ fontSize: 9, color: "#52525b" }}>
                  {brand.language.toUpperCase()} / ${brand.price_usd}
                </div>
              </div>
              <div>
                <span className={`status-badge status-${brand.status}`}>
                  {brand.status === "scaling" && <TrendingUp size={9} strokeWidth={2} />}
                  {brand.status}
                </span>
              </div>
              <div className="font-mono" style={{ textAlign: "right", fontSize: 12, color: "#d4d4d8" }}>
                {brand.total_sales}
              </div>
              <div className="font-mono" style={{ textAlign: "right", fontSize: 12, color: "#34C759" }}>
                ${brand.revenue_usd.toLocaleString()}
              </div>
              <div className="font-mono" style={{
                textAlign: "right", fontSize: 12,
                color: roiPositive ? "#34C759" : "#FF3B30",
                display: "flex", alignItems: "center", justifyContent: "flex-end", gap: 2
              }}>
                {roiPositive ? <TrendingUp size={10} strokeWidth={1.5} /> : <TrendingDown size={10} strokeWidth={1.5} />}
                {roi}%
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
